export default __webpack_public_path__ + "static/media/daikon_01-2.c4e96b68.jpg";